<template>
  <tr>
    <td>{{ alumno.nombre }} {{ alumno.apellido }}</td>
    <td>{{ alumno.perfil.nombre }}</td>
    <td>{{ alumno.es_alumno_de.nombre }} {{ alumno.es_alumno_de.apellido }}</td>
  </tr>
</template>

<script>
// import mentorService from '../services/mentor'
export default {
  name: 'AlumnosPorProfeListaItem',
  components: {
  },
  props: ['alumno'],
  data: function () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style>

</style>
